import { FC } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "antd";

import styles from "./Logout.module.scss";

import { pages } from "@/root/consts";
import { useAppDispatch } from "@/hooks/redux";
import { clearAuthToken } from "@/utils/tokenHelpers";
import { resetUserState } from "@/store/reducers/user/userSlice";
import { resetCurrentDataState } from "@/store/reducers/currentData/currentDataSlice";
import { resetServerConnectionState } from "@/store/reducers/serverConnection/serverSlice";
import { resetSettingsState } from "@/store/reducers/settings/settingsSlice";
import { closeServerSocketConnection } from "@/store/reducers/serverConnection/asyncActionCreators";
import { clearExaminationForm } from "@/store/reducers/examinationForm/examinationFormSlice";

const Logout: FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleLogoutClick = () => {
    try {
      dispatch(clearExaminationForm());
      dispatch(resetUserState());
      dispatch(resetCurrentDataState());
      dispatch(resetServerConnectionState());
      dispatch(resetSettingsState());
      dispatch(closeServerSocketConnection());
      clearAuthToken();
    } catch (e) {
    } finally {
      navigate(pages.login.path);
    }
  };

  return (
    <Button className={styles.button} onClick={handleLogoutClick}>
      Logout
    </Button>
  );
};

export default Logout;
